// extracted by mini-css-extract-plugin
export default {"horizontalLine":"NextVerificationModal_horizontalLine__yf-N5"};